<app-table [data]="issues"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [headerBackgroundColor]="headerBackgroundColor"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           title="{{'admin.issues.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column [header]="'admin.tool-history.lifecycle-history-table.columns.line' | translate"
                      [filterPlaceholder]="'admin.tool-history.lifecycle-history-table.filter.placeholder.line' | translate"
                      [filter]="true"
                      [sortable]="true"
                      field="line">
        <ng-template #body
                     let-issue="rowData">
            <span>{{ issue.line.name }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.issues.table.columns.status' | translate}}"
                      filterPlaceholder="{{'admin.issues.table.filter.placeholder.status' | translate}}"
                      filter="true"
                      sortable="true"
                      field="status">
    </app-table-column>
    <app-table-column header="{{'admin.issues.table.columns.reason' | translate}}"
                      sortable="true"
                      field="reason">
        <ng-template #body
                     let-issues="rowData">
            <span>{{ issues.reason.name }}</span>
        </ng-template>
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="filterReasons"
                          valueField="value"
                          displayField="name"
                          emptyText="{{'admin.issues.table.filter.placeholder.reason' | translate}}"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.issues.table.columns.createdAt' | translate}}"
                      sortable="true"
                      field="createdAt">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-input-datepicker [(ngModel)]="column.filterValue"
                                  outputDateFormat="timestamp"
                                  [appendTo]="'body'"
                                  placeholder="{{'admin.issues.table.filter.placeholder.createdAt' | translate}}"
                                  (dateChange)="table.onFilterChange(column)">
            </app-input-datepicker>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'admin.issues.table.columns.createdBy' | translate}}"
                      filterPlaceholder="{{'admin.issues.table.filter.placeholder.createdBy' | translate}}"
                      filter="false"
                      sortable="true"
                      field="createdBy">
        <ng-template #body
                     let-issues="rowData">
            <span>{{ issues.user.fullName }}</span>
        </ng-template>
    </app-table-column>
</app-table>
